import { render } from "./OpeningBalanceModal.vue?vue&type=template&id=0f042caa&scoped=true"
import script from "./OpeningBalanceModal.vue?vue&type=script&lang=js"
export * from "./OpeningBalanceModal.vue?vue&type=script&lang=js"

import "./OpeningBalanceModal.vue?vue&type=style&index=0&id=0f042caa&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f042caa"]])

export default __exports__